import type { Resolver } from 'react-hook-form';
import { newsletterSchema, type NewsletterFormData } from './newsletter.schema';

/**
 * Local Zod resolver — avoids depending on `@hookform/resolvers` in layout.
 * Declaring that package here hoists it next to root zod@3.25 and breaks
 * storefront-checkout's zodResolver typecheck in CI.
 */
export const newsletterResolver: Resolver<NewsletterFormData> = async (values) => {
  const parsed = newsletterSchema.safeParse(values);
  if (parsed.success) {
    return { values: parsed.data, errors: {} };
  }

  const issue = parsed.error.issues[0];
  const field = (issue?.path[0] as keyof NewsletterFormData | undefined) ?? 'email';
  return {
    values: {},
    errors: {
      [field]: {
        type: issue?.code ?? 'validation',
        message: issue?.message ?? 'Invalid email',
      },
    },
  };
};
